var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.sendForm($event)
        }
      }
    },
    [
      _c(
        "button",
        {
          staticClass: "k-btn",
          class: [
            _vm.isWatching ? "k-btn--secondary-outline" : "k-btn--primary"
          ],
          attrs: { type: "submit" }
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.isWatching
                  ? "Zrušit sledování"
                  : "Sledovat " + _vm.targetTitle
              ) +
              "\n    "
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }